import { render, staticRenderFns } from "./BasePositionCheckbox.vue?vue&type=template&id=0af2fc99&scoped=true&"
import script from "./BasePositionCheckbox.vue?vue&type=script&lang=ts&"
export * from "./BasePositionCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./BasePositionCheckbox.vue?vue&type=style&index=0&id=0af2fc99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af2fc99",
  null
  
)

export default component.exports